define('app/visualizations/PieChart',['require','./SimpleCategoricalChartView'],function(require) {
	'use strict';

	var SimpleCategoricalChartView = require('./SimpleCategoricalChartView');

	var MAX_RECORDCOUNT = 50;

	return SimpleCategoricalChartView.extend({
		type: 'pie',

		getMaxRecordCount: function() {
			return MAX_RECORDCOUNT;
		},

		/**
		 * Get data used to populate the chart.
		 */
		getChartData: function(results) {
			return results.pieData();
		},

		/**
		 * Get default options for rendering the chart.  Also provides callers the opportunity to customize
		 * various settings such as height, width, etc.
		 */
		getChartOptions: function(data) {
			var self = this;

			var options = {
				c3: {
					size: {
						height: this.height || this.$el.height(),
						width: this.width
					},
					legend: {
						position: 'right',
						show: this.showLegend
					},
					data: {
						type: this.type,
						columns: data,
						onclick: function(d) {
							self.onClickChart(d);
						}
					},
					padding: {
						top: this.paddingTop,
						right: this.paddingRight,
						bottom: this.paddingBottom,
						left: this.paddingLeft
					}
				}
			};

			if (this.fixToolTips) {
				options.c3.tooltip = {
					position: function() {
						return {
							top: 0,
							left: 0
						};
					}
				};
			}

			return options;
		}
	});

});

